import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NewsletterSignup from './NewsletterSignup';

const SECTION = { display: 'flex', flexDirection: 'column', gap: 10 };
const TITLE = { fontFamily: 'DM Mono, monospace', fontSize: 11, letterSpacing: 2, color: '#D4AF37', textTransform: 'uppercase', marginBottom: 8 };
const LINK = { color: '#D1D5DB', textDecoration: 'none', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 14, lineHeight: 1.6 };

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="pb-footer" style={{
      background: '#0A1428',
      color: '#fff',
      padding: '64px 24px 32px',
      marginTop: 80,
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 40 }}>
        <div>
          <Link to="/" style={{ color: '#fff', textDecoration: 'none', fontFamily: 'Playfair Display, serif', fontSize: 24, fontWeight: 700, letterSpacing: 1 }}>
            Private Brands
          </Link>
          <p style={{ marginTop: 12, fontFamily: 'Cormorant Garamond, serif', fontSize: 16, color: '#E5E7EB', lineHeight: 1.6 }}>
            {t('footer.tagline')}
          </p>
          <p style={{ marginTop: 10, fontFamily: 'DM Mono, monospace', fontSize: 11, color: '#D4AF37', letterSpacing: 1, lineHeight: 1.5 }}>
            {t('footer.developed_by')}
          </p>
        </div>

        <div style={SECTION}>
          <div style={TITLE}>{t('footer.section_platform')}</div>
          <Link to="/branduri" style={LINK}>{t('footer.link_branduri')}</Link>
          <Link to="/banking" style={LINK}>{t('footer.link_banking')}</Link>
          <Link to="/metodologie" style={LINK}>{t('footer.link_metodologie')}</Link>
          <Link to="/preturi" style={LINK}>{t('footer.link_preturi')}</Link>
        </div>

        <div style={SECTION}>
          <div style={TITLE}>{t('footer.section_resources')}</div>
          <Link to="/blog" style={LINK}>{t('footer.link_blog')}</Link>
          <Link to="/glosar" style={LINK}>{t('footer.link_glosar')}</Link>
          <Link to="/raport-2026" style={LINK}>{t('footer.link_raport')}</Link>
          <a href="/piata-carduri-romania.html" style={LINK}>{t('footer.link_carduri')}</a>
        </div>

        <div style={SECTION}>
          <div style={TITLE}>{t('footer.section_account')}</div>
          <Link to="/login" style={LINK}>{t('footer.link_login')}</Link>
          <Link to="/register" style={LINK}>{t('footer.link_register')}</Link>
        </div>

        <div style={SECTION}>
          <div style={TITLE}>{t('footer.section_legal')}</div>
          <Link to="/politica-confidentialitate" style={LINK}>{t('footer.link_privacy')}</Link>
          <Link to="/termeni-si-conditii" style={LINK}>{t('footer.link_terms')}</Link>
          <Link to="/cookies" style={LINK}>{t('footer.link_cookies')}</Link>
          <Link to="/sub-procesatori" style={LINK}>{t('footer.link_subprocessors')}</Link>
          <Link to="/retur" style={LINK}>{t('footer.link_refund')}</Link>
          <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer" style={LINK}>ANPC</a>
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={LINK}>SOL — Online Dispute Resolution</a>
        </div>

        <div style={SECTION}>
          <div style={TITLE}>{t('footer.section_contact')}</div>
          <a href="mailto:contact@privatebrands.ro" style={LINK}>contact@privatebrands.ro</a>
          <a href="https://www.linkedin.com/company/private-brands-ro" target="_blank" rel="noopener noreferrer" style={LINK}>LinkedIn</a>
        </div>

        <div style={{ ...SECTION, gridColumn: '1 / -1', marginTop: 16, borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24 }}>
          <div style={TITLE}>{t('footer.newsletter_title')}</div>
          <p style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, color: '#D1D5DB', marginBottom: 8, lineHeight: 1.5 }}>
            {t('footer.newsletter_desc')}
          </p>
          <div style={{ maxWidth: 360 }}>
            <NewsletterSignup variant="inline" source="footer" />
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: 1200,
        margin: '40px auto 0',
        paddingTop: 24,
        borderTop: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        fontFamily: 'DM Mono, monospace',
        fontSize: 11,
        color: '#D1D5DB',
      }}>
        <div style={{ lineHeight: 1.7 }}>
          © {new Date().getFullYear()} Private Brands. {t('footer.copyright')}<br/>
          {t('footer.company_details')}<br/>
          {t('footer.hq')}
        </div>
        <div>{t('footer.hosted')}</div>
      </div>
    </footer>
  );
}
